<template>
    <div class="container-fluid py-5">
        <!-- Date Range Picker -->
        <!-- Toggle Button -->
        <div class="row">
            <div class="col-4 col-md-6">
                <h4 class="mb-0">Rooms</h4>
                <hr class="w-50" />
                <a class="btn btn-sm btn-primary" @click="toggleView">
                                {{ showAll ? 'Show Available Only' : 'Show All Rooms' }}
                            </a>
            </div>
            <div class="col-8 col-md-6">
                <p>Select date to see room availability</p>
                <date-range-picker :auto-apply="autoApply" v-model="dateRange" :ranges="ranges" :opens="datepicker_opens" :append-to-body="append_to_body" class="custom-width-datepicker">
                    <template #input="picker" style="width: 100% !important;">
                         <p v-if="picker.startDate !==null && picker.endDate !==null">{{ formatDate(picker.startDate,'DD-MMM-YYYY') }} - {{ formatDate(picker.endDate,'DD-MMM-YYYY') }}</p>
                                                                                    <p v-else><i class="bi bi-calendar-event"></i>  Filter by Date</p>
</template>
                                            </date-range-picker>
            </div>
         </div>
        <div class="d-flex justify-content-between align-items-center mb-3">



        </div>
        <!-- Rooms Grid -->
        <div class="row">
            <div class="col-md-3 mb-3" v-for="room in filteredRooms" :key="room.id">
                <div class="card text-center h-100 d-flex align-items-center justify-content-center" :class="{
                'border-success': room.is_available,
                'border-secondary': !room.is_available
              }" style="cursor: pointer; height: 150px;" @click="openReservation(room)">
                    <div class="card-body d-flex align-items-center justify-content-center">
                        <h4 class="mb-0">{{ room.product }}</h4>
                    </div>
                </div>
            </div>
        </div>
        <!-- Reservation Modal -->
  <b-modal ref="reservationModal" size="lg" hide-footer static hide-header>
            <div v-if="reservationError" class="card bg-danger">
                <div class="card-body">
                    <h4>Ooops! There was an error with your reservation</h4>
                  <ul>
                    <li v-for="(messages, field) in reservationError" :key="field">
                        <span v-for="msg in messages" :key="msg">{{ msg }}</span>
                    </li>
                    </ul>
                </div>

            </div>
                    <div class="text-center pt-5 pb-">
                        <h5 class="py-2">Booking - {{ selectedRoom?.product }}</h5>
                        <p class="pb-3">{{ formatDate(dateRange.startDate,'DD-MMM-YYYY') }} to {{ formatDate(dateRange.endDate,'DD-MMM-YYYY') }} </p>
                    </div>
                        <div class="form-group">
                            <button class="btn btn-block btn-outline-dark" @click="showCustomersModal">
                                    <span class="h5">
                                        <i class="bi bi-person-circle"></i>
                                    </span>
                                    <span v-if="selectedCustomer">
                                        {{selectedCustomer.full_name}}
                                    </span>
                                    <span v-else class="text-danger">
                                        Add Customer Details
                                    </span>
                                    </button>
                        </div>
                        <!-- Guests -->
                         <div class="form-row py-3">
                            <p>Adjust dates</p>
                            <date-range-picker :auto-apply="autoApply" v-model="dateRange" :ranges="ranges" :opens="datepicker_opens" :append-to-body="append_to_body" class="custom-width-datepicker">
                                <template #input="picker" style="width: 100% !important;">
                                    <p v-if="picker.startDate !==null && picker.endDate !==null">
                                        {{ formatDate(picker.startDate,'DD-MMM-YYYY') }} - {{ formatDate(picker.endDate,'DD-MMM-YYYY') }}</p>
                                    <p v-else><i class="bi bi-calendar-event"></i> Filter by Date</p>
                                </template>
                            </date-range-picker>
                            <hr />
                         </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label>Adults</label>
                                <input type="number" v-model="reservation.adults" class="form-control" min="1" />
                            </div>
                            <div class="form-group col-md-6">
                                <label>Children</label>
                                <input type="number" v-model="reservation.children" class="form-control" min="0" />
                            </div>
                        </div>

                        <div v-if="selectedRoom">
  <div v-for="variation in selectedRoom.variations"
       :key="variation.id"
       class="form-check form-check-inline">

    <input class="form-check-input"
           type="radio"
           v-model="reservation.board_type"
           :id="'radio' + variation.id"
           name="board_type"
           :value="variation.board_type">

    <label class="form-check-label"
           :for="'radio' + variation.id">
      {{ variation.name }}
    </label>
  </div>
</div>

                        <!-- Estimate -->
<div class="container my-4" v-if="quote">
  <div class="card shadow-sm">
    <div class="card-header bg-secondary text-white">
      <h4 class="mb-0">Reservation Quote</h4>
    </div>
    <div class="card-body">
      <!-- Stay Summary -->
      <h5 class="mb-3">Stay Details</h5>
      <ul class="list-group list-group-flush">
        <li>
          <span>Check-In: </span>
          <strong>{{ quote?.check_in }}</strong>
        </li>
        <li>
          <span>Check-Out: </span>
          <strong>{{ quote?.check_out }}</strong>
        </li>
        <li>
          <span>Nights: </span>
          <strong>{{ quote?.nights }}</strong>
        </li>
        <li>
          <span>Guests: </span>
          <strong>{{ quote?.adults }} Adult(s), {{ quote?.children }} Child(ren)</strong>
        </li>
      </ul>

      <!-- Price Breakdown -->
      <h5 class="mb-3">Price Breakdown</h5>
      <div v-for="(segment, idx) in quote?.segments" :key="idx" class="mb-3">
        <div class="border rounded p-3">
          <p class="mb-1"><strong>Board:</strong> {{ segment.board_type || 'Room Only' }}</p>
          <p class="mb-1"><strong>Rate per Night:</strong> {{ segment.rate_per_night }}</p>
          <p class="mb-1"><strong>Nights:</strong> {{ segment.nights }}</p>
          <p class="mb-0"><strong>Total:</strong> {{ convertCurrencyToLocal(segment.price_total) }}</p>
        </div>
      </div>

      <!-- Total -->
      <div class="alert alert-info d-flex justify-content-between align-items-center">
        <strong>Total Price</strong>
        <h4 class="mb-0">{{ convertCurrencyToLocal(quote?.total) }}</h4>
      </div>
    </div>
  </div>
</div>

                        <div class="row">
                            <div class="col-6">
                                <button @click="getQuote" class="btn btn-outline-primary btn-block">Get Quote</button>
                            </div>
                            <div class="col-6">
                                <button v-b-modal="'paymentModal'" v-if="quote" class="btn btn-primary btn-block">Proceed to Book & Pay</button>
                            </div>


                        </div>
  </b-modal hide-footer static hide-header>

        <!-- Payment Modal -->
       <b-modal ref="process_payment" id="paymentModal" hide-footer static hide-header>
        <div class="text-center py-3">
           <h2>Payment Details</h2>
        </div>
        <form @submit.prevent="makeReservation">
            <div class="form-group">
                        <select v-model="reservation.paymentMethod" class="form-control">
                            <option value="null">Choose Mode of Payment</option>
                            <option :value="method.id"  v-for="method in paymentMethods" :key="method.id">{{ method.payment_method }}</option>
                        </select>

                           </div>
                        <div class="form-group">
                            <input v-if="quote" class="form-control" v-model="quote.total"/>
                        </div>
                        <div class="form-group">
                            <button type="submit" class="btn btn-block btn-primary" >Complete payment</button>
                        </div>


        </form>



        </b-modal>

        <b-modal ref="new-customers-modal" hide-footer static>

            <div class="row">
                <div class="col"><a @click="showCustomersModal"><h6 class="text-primary"><i class="fas fa-angle-left"></i> Back</h6></a></div>
                <div class="col text-centre"><h2 class="font-weight-bold text-dark ">Add Customer</h2></div>
                </div>
                <div class="text-left" v-html="successMessage">{{successMessage}}</div>
                <div class="text-left text-danger py-2" v-if="customerForm.errorMessage !==''">{{customerForm.errorMessage}}</div>
                <div class="container py-3">
                    <!-- Actual search box -->
                    <form @submit.prevent="newCustomerInfo">
                        <div class="form-row py-1">
                            <div class="col-6">
                                <input class="form-control border-bottom"   v-model="customerForm.f_name" name="f_name" type="text" placeholder="First Name"/>
                                <!--<small class="text-danger">{{ errors.first('f_name') }}</small>-->

                            </div>
                            <div class="col-6">
                                <input class="form-control border-bottom"  v-model="customerForm.l_name" name="l_name" type="text" placeholder="Last Name"/>
                                <!--<small class="text-danger">{{ errors.first('l_name') }}</small>-->
                            </div>
                        </div>
                        <div class="form-group py-1">

                            <input class="form-control border-bottom" name="c_email" v-model="customerForm.c_email" type="email" placeholder="Email"/>


                        </div>
                        <div class="form-group">

                            <input class="form-control border-bottom"   v-model="customerForm.phone_no" name="phone_no" type="text" placeholder="Phone Number"/>


                        </div>
                        <div class="form-row py-1">
                            <div class="col-6">
                                <input class="form-control border-bottom" v-model="customerForm.h_no" name="h_no" type="text" placeholder="House Number"/>
                            </div>
                            <div class="col-6">
                                <input class="form-control border-bottom" v-model="customerForm.apartment" name="apartment" type="text" placeholder="Apartment"/>
                            </div>
                        </div>
                        <div class="form-row py-1">
                            <div class="col-6">
                                <input class="form-control border-bottom" v-model="customerForm.street" name="street" type="text" placeholder="Street"/>
                            </div>
                            <div class="col-6">
                                <input class="form-control border-bottom" v-model="customerForm.town" name="town" type="text" placeholder="Town"/>
                            </div>
                        </div>
                        <div class="form-group pt-3">
                            <button class="btn btn-primary btn-block">Add Customer</button>
                        </div>
                    </form>
                </div>



        </b-modal>
         <b-modal id="customer-modal-sales" ref="customers-modal" hide-footer static>
            <div class="row">

                <div class="col"><h2 class="font-weight-bold ">{{selectedCustomer?.full_name}}</h2></div>
                <div class="col d-flex justify-content-end">

                    <a class="btn btn-primary btn-sm " @click="AddnewcustomerModal">New Customer <i class="bi bi-plus-square-fill "></i></a>
                </div>

                <div class="container py-3">

                  <!-- Actual search box -->
                  <div class="form-group has-search">
                      <span class="fa fa-search form-control-feedback"></span>
                      <input type="text" v-model="searchCustomer" class="form-control border" placeholder="Search">
                  </div>
                  <ul>
                      <li class="border-bottom" v-if="customer" v-for="customer in allCustomersFiltered" v-bind:key='customer.id' @click="SelectCustomer(customer)">
                          <div class="row">
                              <div class="col-6">  <h6 v-if="customer.full_name" class="text-left">{{customer.full_name}}</h6>
                                  <p class="text-gray d-inline">{{customer.address_address}}</p></div>
                              <div class="col-6">
                                  <p class="text-gray text-right">{{customer.phone}}</p>
                              </div>


                          </div>


                      </li>

                  </ul>
              </div>

            </div>

        </b-modal>
    </div>

</template>

<script>
    import axios from "axios";
    import format from 'date-fns/format'
    import {
        mapGetters
    } from 'vuex'
    import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker";
    import customerCacheService from "../IndexDB/customerCacheService";
    export default {
        components: {
            DateRangePicker
        },
        data() {
            return {
                rooms: [],
                showAll: true,
                dateRange: {
                    startDate: moment().startOf("day"), // today
                    endDate: moment().add(1, "days").startOf("day"), // tomorrow
                },
                autoApply: true,
                append_to_body: true,
                datepicker_opens: 'right',
                ranges: false,
                selectedRoom: null,
                selectedCustomer: null,
                customers: [],
                newCustomer: "",
                reservation: {
                    customer_id: null,
                    product_id: null,
                    adults: 1,
                    children: 0,
                    paymentMethod: null,
                    board_type: null,
                },
                reservationMessage: null,
                successMessage: '',
                allCustomers: '',
                searchCustomer: '',
                paymentMethods: [],
                successMessage: '',
                reservationError: null,
                quote: null,
                customerForm: {
                    town: '',
                    street: '',
                    apartment: '',
                    h_no: '',
                    phone_no: '',
                    c_email: '',
                    l_name: '',
                    f_name: '',
                    errorMessage: '',
                },
            };
        },
        computed: {
            filteredRooms() {
                // if (this.showAll) return this.rooms;
                // return this.rooms.filter((r) => r.is_available);
                return this.rooms;
            },
            nights() {
                const days = moment(this.dateRange.endDate).diff(moment(this.dateRange.startDate), 'days');
                const nights = days > 0 ? days : 1;
                return nights;
            },
            estimate() {
                if (!this.dateRange || !this.dateRange.startDate || !this.dateRange.endDate || !this.selectedRoom) {
                    return 0;
                }
                // ensure at least 1 day (checkout tomorrow rule)
                return this.selectedRoom.ppu * this.nights;
            },
            allCustomersFiltered() {
                return Object.values(this.allCustomers).filter(customer => {
                    if (!customer || !customer.full_name || !customer.phone) return false;
                    const search = this.searchCustomer.toLowerCase();
                    return (
                        customer.full_name.toLowerCase().includes(search) ||
                        customer.phone.toLowerCase().includes(search)
                    );
                });
            },
        },
        methods: {
            async fetchRooms() {
                const res = await axios.get(`/api/reservations/availability`, {
                    params: {
                        check_in: this.dateRange.startDate,
                        check_out: this.dateRange.endDate,
                        all_rooms: (this.showAll) ? 1 :0
                    },
                });
                this.rooms = res.data;
            },
            async getPaymentGateways() {
                await axios.get('/api/payments').then(results => {
                    this.paymentMethods = results.data
                })
            },
            async makeReservation() {
                try {
                    if (!this.quote) {
                        await this.getQuote()
                    }
                    const res = await axios.post("/api/reservations", {
                        ...this.reservation,
                        check_in: this.dateRange.startDate,
                        check_out: this.dateRange.endDate,
                        total_amount: this.quote.total,
                        status: 'confirmed',
                        payment_method: this.reservation.paymentMethod
                    });

                    setTimeout(()=>{
                        this.$toasts.push({
                            'type': "success",
                            "message": "Reservation succesfull"
                        })
                       window.location.href = '/reservations';
                    },5000)


                } catch (err) {
                    if (err.response) {
                        this.reservationError = err.response.data.errors;
                        this.$refs.process_payment.hide()
                        this.$toasts.push({
                            'type': "error",
                            "message": "There was an error creating your reservation"
                        })
                        console.error("Validation/Server Error:", err.response.data);
                    } else if (err.request) {
                        // Request was sent but no response received
                        console.error("No response from server:", err.request);
                    } else {
                        // Something else happened
                        console.error("Error setting up request:", err.message);
                    }
                }
            },
            async getQuote() {
                try {
                    const res = await axios.post("/api/reservations/quote", {
                        ...this.reservation,
                        check_in: this.dateRange.startDate,
                        check_out: this.dateRange.endDate,
                        total_amount: typeof this.estimate === "function" ?
                            this.estimate() :
                            this.estimate
                    });
                    this.quote = res.data // success response
                    this.getPaymentGateways()
                } catch (err) {
                    this.reservationError = err.response?.data?.errors || {};
                    console.error(err.response?.data || err); // safer logging
                }
            },
            async getCustomers() {
                try {

                    const customers = await customerCacheService.getCustomers(this.searchCustomer,true);

                    this.allCustomers = customers;
                } catch (error) {}
            },
            newCustomerInfo() {
                if (this.customerForm.phone_no === '' && this.customerForm.c_email === '') {
                    this.customerForm.errorMessage = "You need to enter atleast an email or customer phone number"
                } else {
                    this.customerForm.errorMessage = ''
                    axios.post('/api/newcustomer', {
                            ...this.customerForm
                        })
                        .then(result => {
                            if (result.status === 200) {
                                setTimeout(() => {
                                    this.successMessage = "<hr/><p><span class='text-success'><i class=\"bi bi-check-circle\"></i>  Customer added successfully</span></p>"
                                }, 3000)
                                this.$refs['new-customers-modal'].hide()
                                this.$refs['customers-modal'].hide()
                                this.selectedCustomer = result.data.customer
                            }
                        });
                }
            },
            SelectCustomer(customer) {
                this.$refs['customers-modal'].toggle();
                this.selectedCustomer = customer
                this.reservation.customer_id = customer.id
                this.reservationError = null
            },
            async toggleView() {
                this.showAll = !this.showAll;
                await this.fetchRooms()
            },
            openReservation(room) {
                this.selectedRoom = room;
                this.reservation.product_id = room.id
                this.$refs['reservationModal'].show();
            },
            proceedPayment() {
                $("#reservationModal").modal("hide");
                $("#paymentModal").modal("show");
            },
            completePayment(method) {
                alert(`Reservation confirmed with ${method}`);
                $("#paymentModal").modal("hide");
            },
            showCustomersModal() {
                this.getCustomers()
                this.$refs['new-customers-modal'].hide();
                this.$refs['customers-modal'].show();
            },
            showCustomersModalFinal() {
                this.$refs['default-customers'].hide();
                this.$refs['customers-modal-final'].show();
            },
            AddnewcustomerModal() {
                this.$refs['customers-modal'].hide();
                this.$refs['new-customers-modal'].show();
            },
            formatDate(date, format) {
                let finaldate = moment(date).format(format);
                return finaldate;
            },

        },
        mounted() {
            this.fetchRooms();
        },
    };
</script>
